import React from "react";
import { TbCurrencyTaka } from "react-icons/tb";
import { HiUserGroup } from "react-icons/hi";
import { MdDoubleArrow } from "react-icons/md";
import { AiFillSchedule } from "react-icons/ai";
import { TiTick } from "react-icons/ti";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import UseTitle from "../../Hooks/UseTitle";
import premiumCover from "../../../Assets/Hompage/Premium/premium (4).jpeg";
import premiumCoverMobile from "../../../Assets/Room 4_mobile.jpg";
import premium1 from ".././../../Assets/Hompage/Premium/premium (1).jpeg";
import premium2 from ".././../../Assets/Hompage/Premium/premium (2).jpeg";
import premium3 from ".././../../Assets/Hompage/Premium/premium (3).jpeg";
import premium5 from ".././../../Assets/Hompage/Premium/premium (5).jpeg";
import { Link } from "react-router-dom";

const PremiumSuite = () => {
  UseTitle("Premium Room");
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <div className="bg-gray-100">
      <div className="md:block hidden ">
        <img src={premiumCover} alt="premium" className="w-full" />
      </div>
      <div className="md:hidden block ">
        <img src={premiumCoverMobile} alt="premium" className="w-full" />
      </div>
      <div className="max-w-screen-xl mx-auto ">
        <div className="py-10 md:px-20 px-5 bg-white">
          <h2 className="text-[50px] text-gray-800 text-center md:text-start">
            Premium{" "}
          </h2>
          <div className="pt-8  gap-10 place-items-center md:place-items-start grid grid-cols-1 md:grid-cols-2 ">
            <div>
              <p className="flex text-[16px] md:text-[20px] gap-5 md:gap-10 items-center">
                <span>
                  <TbCurrencyTaka />
                </span>
                <span>BDT 10,000++</span>
              </p>
            </div>
            <div>
              <p className="flex  md:text-[20px] gap-5 md:gap-10 items-center">
                <span>
                  <HiUserGroup />
                </span>
                <span>Occupancy</span>
                <span className="text-[14px] md:text-[20px]">
                  Up to 2 adults and 2 kids.
                </span>
              </p>
            </div>
          </div>
          <div className="py-20">
            <p className="text-[16px]">
              On the first floor of our Villas, we have spacious rooms featuring
              king-sized beds facing toward a balcony that overlooks the
              tranquil lake. These rooms are perfect for families and friends,
              offering a comfortable space to unwind while enjoying the
              surrounding view of nature. The room features multiple giant
              windows, as well as a porch and balcony that provide breathtaking
              views of the surrounding natural beauty and the serene lake.
            </p>
          </div>
        </div>

        <div className="px-5 md:px-0">
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlaySpeed={2000}
            autoPlay={true}
            customTransition="all .5"
          >
            <div>
              <img src={premium1} alt="premium" className="w-full" />
            </div>
            <div>
              <img src={premium2} alt="premium" className="w-full" />
            </div>
            <div>
              <img src={premium3} alt="premium" className="w-full" />
            </div>
            <div>
              <img src={premium5} alt="premium" className="w-full" />
            </div>
          </Carousel>
        </div>
        <div className="py-20">
          <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
            <div className="flex justify-center items-start">
              <div>
                <h2 className="text-[45px] mb-10 text-center md:text-start">
                  Room Amenities
                </h2>
                <p className="flex items-center gap-5 text-[18px]">
                  <span>
                    <MdDoubleArrow />
                  </span>
                  <span>300 Sft.</span>
                </p>
                <p className="flex items-center gap-5 text-[18px]">
                  <span>
                    <MdDoubleArrow />
                  </span>
                  <span>Occupancy for 2 adults and 2 kids</span>
                </p>
                <p className="flex items-center gap-5 text-[18px]">
                  <span>
                    <MdDoubleArrow />
                  </span>
                  <span>One Bed Room, 1 Bath, 1 balcony</span>
                </p>
                <p className="flex items-center gap-5 text-[18px]">
                  <span>
                    <MdDoubleArrow />
                  </span>
                  <span>Large Master Bedroom with King Size Bed.</span>
                </p>
                <p className="flex items-center gap-5 text-[18px]">
                  <span>
                    <MdDoubleArrow />
                  </span>
                  <span>Large Bathroom.</span>
                </p>

                <div className="my-20">
                  <Link to="/Online_Booking">
                    <button
                      type="button"
                      class="text-white w-full text-[30px] bg-[#FF9119] hover:bg-[#FF9119]/80 focus:ring-4 focus:outline-none focus:ring-[#FF9119]/50 font-bold px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-[#FF9119]/80 dark:focus:ring-[#FF9119]/40 mr-2 mb-2"
                    >
                      <AiFillSchedule className="mr-5" />
                      Book Now
                    </button>
                  </Link>
                </div>
              </div>
            </div>

            <div>
              <div class="flex justify-center flex-col p-6 bg-white border border-gray-200 rounded-lg shadow-md roomsBg">
                <h2 className="text-[45px] mb-10 text-center">
                  Complimentary Benefits
                </h2>

                <div className="flex justify-center">
                  <div>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Welcome Drink</span>
                    </p>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Breakfast </span>
                    </p>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Toiletries with room</span>
                    </p>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Swimming Pool</span>
                    </p>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Play Ground for different games</span>
                    </p>
                    <p className="flex items-center gap-5 text-[18px]">
                      <span>
                        <TiTick />
                      </span>
                      <span>Kids Zone </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PremiumSuite;
